export default __webpack_public_path__ + "components/weather-icon/static/dayclear-faae756b5049823a0245be47071b1cd9.webp";